import { useState } from "react";
import { toast } from "sonner";
import { CreditCard } from "lucide-react";
import { api } from "@/lib/api";
import { CardFacts, CardCondition, CardPhotoTips } from "../cards/CardDetails";
import CardPrices from "../cards/CardPrices";

export default function CardModeCard({ draft, patch }) {
  const [busy, setBusy] = useState(false);
  const card = draft?.card;
  if (!card?.kind) return null;

  const check = async () => {
    setBusy(true);
    try {
      const { data } = await api.post(`/drafts/${draft.id}/card-prices`);
      patch({ card_prices: data });
    } catch (e) {
      toast.error(e?.response?.status === 404 ? "Save the draft first, then check prices" : e?.response?.data?.detail || "Price check failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="space-y-2 rounded-lg border border-slate-900/10 bg-slate-50 p-3" data-testid="card-mode-card">
      <div className="flex items-center gap-2">
        <CreditCard className="h-4 w-4 text-slate-900" />
        <span className="text-sm font-semibold text-slate-900">Card mode</span>
        <span className="rounded-full bg-slate-900 px-2 py-0.5 font-mono text-[10px] text-white" data-testid="card-kind">{card.kind === "tcg" ? "Trading card game" : "Sports card"}</span>
      </div>
      <CardFacts card={card} />
      <CardCondition card={card} />
      <CardPhotoTips tips={card.missing_photos} />
      <CardPrices prices={draft.card_prices} busy={busy} onCheck={check}
        onPick={(v) => { patch({ price: Number(v).toFixed(2) }); toast.success(`Price set to $${Number(v).toFixed(2)}`); }} />
      <p className="text-[10px] text-slate-400">Grades are AI estimates from photos, not a guarantee. Posting uses eBay's card conditions (graded or ungraded).</p>
    </div>
  );
}
